import { useTranslation } from "react-i18next";
import { Link, useLocation, useParams } from "react-router";
import { ArrowLeft } from "lucide-react";

import { useCenter } from "../../../center";
import { PractitionerReportView } from "../../../reports";
import CenterAdminShell from "../components/CenterAdminShell";

/**
 * One of a training centre's courses across its mentors: each mentor's
 * share, each student, each mentorship with its module, and the statement.
 */
export default function CenterCourseReportPage() {
    const { t } = useTranslation();
    const { courseId = "" } = useParams();
    const { state } = useLocation() as { state: { label?: string } | null };
    const { center, loading } = useCenter();

    if (loading || !center) {
        return <p className="p-6 text-sm text-content-secondary">{t("common.loading")}</p>;
    }

    const name = state?.label ?? t("reports.courses.thisCourse");
    return (
        <CenterAdminShell center={center} title={t("reports.courses.reportTitle", { name })}>
            <PractitionerReportView
                scope={{ kind: "course", centerId: center.id, courseId }}
                title={t("reports.courses.reportTitle", { name })}
                subtitle={t("reports.courses.reportSubtitle")}
                headerAction={
                    <Link
                        to="/center/reports?section=courses"
                        className="mb-2 inline-flex items-center gap-1.5 text-sm text-content-secondary hover:text-content-primary"
                    >
                        <ArrowLeft size={16} aria-hidden="true" />
                        {t("reports.backToCenter")}
                    </Link>
                }
            />
        </CenterAdminShell>
    );
}
